import {
  FETCHING_DONATION_SUMMARY,
  FETCHING_DONATION_SUMMARY_FAILED,
  FETCHING_DONATION_SUMMARY_SUCCESS,
  FETCH_DONATION,
  FETCH_DONATION_FAILED,
  FETCH_DONATION_SUCCESS,

  FETCHING_COUNTRY_DONATION_SUMMARY,
  FETCHING_COUNTRY_DONATION_SUMMARY_FAILED,
  FETCHING_COUNTRY_DONATION_SUMMARY_SUCCESS,

  CREATE_DONATION,
  CREATE_DONATION_FAILED,
  CREATE_DONATION_SUCCESS,
} from "./types";

export const initialState = {
  fetchingSummary: false,
  creatingDonations: false,
  summary: {},
  fetchingDonation: false,
  activeDonation: {},
  donations: {
    data: [],
  },
  fetchingCountrySummary: false,
  countrySummary: {},
};

export const donationReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DONATION: return {
      ...state,
      creatingDonations: true
    }
    case CREATE_DONATION_FAILED: return {
      ...state,
      creatingDonations: false
    }
    case CREATE_DONATION_SUCCESS: return {
      ...state,
      creatingDonations: false,
      donations: {
        ...state.donations,
        data: [...action?.donations, ...state?.donations?.data]
      }
    }
    case FETCHING_COUNTRY_DONATION_SUMMARY:
      return {
        ...state,
        fetchingCountrySummary: true,
      };
    case FETCHING_COUNTRY_DONATION_SUMMARY_FAILED:
      return {
        ...state,
        fetchingCountrySummary: false,
      };
    case FETCHING_COUNTRY_DONATION_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchingCountrySummary: false,
        countrySummary: action?.data,
      };
    case FETCH_DONATION:
      return {
        ...state,
        fetchingDonation: true,
      };
    case FETCHING_DONATION_SUMMARY:
      return {
        ...state,
        fetchingSummary: true,
      };
    case FETCHING_DONATION_SUMMARY_FAILED:
      return {
        ...state,
        fetchingSummary: false,
      };
    case FETCHING_DONATION_SUMMARY_SUCCESS:
      return {
        ...state,
        fetchingSummary: false,
        summary: action?.summary,
      };
    case FETCH_DONATION_FAILED:
      return {
        ...state,
        fetchingDonation: false,
      };
    case FETCH_DONATION_SUCCESS:
      return {
        ...state,
        donations: action?.donations,
        fetchingDonation: false,
      };
    default:
      return state;
  }
};
